'use strict';

import React from 'react';

import { OnSchedUtils } from '../../../../../utils'

import NewAllocationItem   from './NewAllocationItem/NewAllocationItem';
import SubmitAllocationRow from './SubmitAllocationRow/SubmitAllocationRow';
import FormCheckbox        from '../../../FormElement/FormCheckbox/FormCheckbox';
import WeeklyAllocations   from './WeeklyAllocations/WeeklyAllocations';


const NewAllocation = ({ newBlock, setNewBlock, element, allocations, setAllocations, onschedState }) => {
  const [blockValues, setBlockValues] = React.useState({})
  const [weeklyAllocations, setWeeklyAllocations] = React.useState(false)
  const [repeats, setRepeats] = React.useState(false)
  const elementRef = React.useRef();

  const colorClasses = 'FormInput onsched-border-border-color onsched-dark-color onsched-primary-border-color-hover onsched-primary-border-color-active onsched-primary-border-color-focus'
  const intervals = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15];

  const nullifyValues = () => {
    const id = new Date().valueOf();
    elementRef.current.id = id;
    setBlockValues(
      Object.assign(
        ...Object.entries(OnSchedUtils.Forms(element).NewBlockForm)
                 .map(([key, value]) => ({ [key]: value.defaultValue })),
        { id }
      )
    );
    setWeeklyAllocations(false);
  }

  React.useEffect(() => nullifyValues(), [])
  // React.useEffect(() => {console.log('blockValues, allocations', blockValues, allocations)}, [blockValues, allocations])

  // const onChange = e => {
  //   const newValues = blockValues;
  //   newValues[e.target.name] = e.target.value;
  //   setBlockValues(newValues);
  // }
  
  // const onBlur = (e) => {
  //   if (!Object.values(blockValues).some(x => x === null || x === '')) {
  //     if (!Object.keys(OnSchedUtils.ValidateForm.BlockedTimeForm(blockValues)).length) {
  //       // Add block to list
  //       onschedState.setState(Object.assign(onschedState.state, { allocations: [...onschedState.state?.allocations ? onschedState.state?.allocations : allocations, blockValues] }))
        
  //       setNewBlock(false);
  //       nullifyValues();
  //     }
  //     else {
  //       Object.keys(OnSchedUtils.ValidateForm.BlockedTimeForm(blockValues))
  //             .map(e => {
  //               document.getElementsByName(e)[0].classList.remove('onsched-border-border-color');
  //               document.getElementsByName(e)[0].classList.add('onsched-danger-border-color');
  //             });
  //     }
  //   }
  // }
  
  const form = OnSchedUtils.Forms(element).NewBlockForm
  const repeatsCheckboxInput = {
    name: 'repeat',
    type: 'checkbox',
    required: false,
    label: OnSchedUtils.Internationalize(element, 'setup_resourceSetup_form_allocations_repeat_label'),
  };

  const repeatsOnChange = e => {
    if (e.target.value === "W") {
      setWeeklyAllocations(true);
    }
    else {
      setWeeklyAllocations(false);
    }
  }

  return (
    <div ref={elementRef} className={`NewAllocation ${newBlock ? 'active' : ''}`}>
      {
        newBlock &&
          <div className='NewAllocationInputs'>
            {Object.keys(form).map((input, idx) => <NewAllocationItem key={idx} element={element} input={form[input]} />)}
            
            <FormCheckbox input={repeatsCheckboxInput} defaultChecked={false} callback={() => setRepeats(!repeats)} />

            {repeats && 
              <>
                <div className={`FormInput AllocationDropdown ${colorClasses}`}>
                  <label>{OnSchedUtils.Internationalize(element, 'setup_resourceSetup_form_allocations_every_label') }</label>
                  <select className="FormDropdown" name="interval">
                    {intervals.map(interval => (<option key={interval} value={interval}>{interval}</option>))}
                  </select>
                </div>

                <div id="repeats-dropdown" className={`FormInput AllocationDropdown ${colorClasses}`}>
                  <label>{OnSchedUtils.Internationalize(element, 'setup_resourceSetup_form_allocations_repeats_label') }</label>
                  <select className="FormDropdown" onChange={repeatsOnChange} name="repeats">
                    <option value="D">{OnSchedUtils.Internationalize(element, 'setup_resourceSetup_form_allocations_daily_label') }</option>
                    <option value="W">{OnSchedUtils.Internationalize(element, 'setup_resourceSetup_form_allocations_weekly_label') }</option>
                    <option value="M">{OnSchedUtils.Internationalize(element, 'setup_resourceSetup_form_allocations_monthly_label') }</option>
                  </select>
                </div>
              </>
            }

          </div>
      }
      <WeeklyAllocations element={element} weeklyAllocations={weeklyAllocations} newBlock={newBlock} repeats={repeats} />
      
      <SubmitAllocationRow element={element} newBlock={newBlock} blockValues={blockValues} setNewBlock={setNewBlock} nullifyValues={nullifyValues} allocations={allocations} setAllocations={setAllocations} />
    </div>
  )
};

export default NewAllocation;
